<button
  mat-icon-button
  matTooltip="View Settings"
  ptElementTarget="view-settings-button"
  [matMenuTriggerFor]="moreMenu"
>
  <mat-icon>tune</mat-icon>
</button>
<mat-menu #moreMenu="matMenu" class="view-settings">
  <form [formGroup]="form">
    <h3 class="settings-heading">View Settings</h3>

    <pt-settings-menu-toggle-group-item
      label="Layout Type"
      formControlName="viewType"
      ptElementTarget="layout-button"
      [options]="viewTypeOptions"
     />

    <pt-settings-menu-toggle-group-item
      label="Size"
      formControlName="size"
      ptElementTarget="size-button"
      [options]="sizeOptions"
     />

    <pt-settings-menu-toggle-group-item
      label="Group By"
      formControlName="groupBy"
      ptElementTarget="group-by-button"
      [options]="groupByOptions"
     />
  </form>
</mat-menu>
